import _keyBy from 'lodash/keyBy';
import _map from 'lodash/map';
import _flatMap from 'lodash/flatMap';

export const designsTransformer = (response) => {
  const designs = _map(response, ({ DesignDocument }) => {
    const { Id, Products } = JSON.parse(DesignDocument);
    return {
      id: Id,
      products: _map(
        Products,
        ({ Sku, ChoiceId, Origin }) => ({ sku: Sku, choiceId: ChoiceId, origin: Origin })),
      bundleChoices: _map(Products, ({ ChoiceId }) => ChoiceId),
      bundleSkus: _map(Products, ({ Sku }) => Sku)
    };
  });
  const normalized = _keyBy(designs, 'id');

  return normalized;
};

export const cabinetdesignsTransformer = (response) => {
  if (!Array.isArray(response)) {
    return response; // Handle cases where the response is not an array
  }

  return response.map((design) => ({
    ...design,
    Matrix: {
      ...design.Matrix,
      Rows: (design.Matrix.Rows / 100) ?? 0,
      Columns: (design.Matrix.Columns / 100) ?? 0,
    },
    Products: (design.Products ?? []).map((product) => {
      if (product && product.Origin) {
        return {
          ...product,
          Origin: {
            Row: product.Origin.Row / 100,
            Column: product.Origin.Column / 100,
            Height: product.Origin.Height / 100,
            Width: product.Origin.Width / 100,
          },
        };
      }
      return product; // Return product unchanged if Origin is missing
    }),
    Cart: (design.Cart ?? []),
  }));
};

export const documentTransformerByDesignType = (response, withConfiguratorBundleData) => {
  const documents = _map(response, (document) => {
    const { ModularDesignType } = document;

    if (ModularDesignType === 'VehicleStorage') {
      const stackProducts = _flatMap(document.Stacks, (stack) => stack.Products);

      if (withConfiguratorBundleData) {
        const stacksWithSku = document.Stacks.filter((stack) => stack.Sku);
        const bundleSkus = stacksWithSku.length > 0
          ? _map(stacksWithSku, ({ Sku }) => Sku)
          : _flatMap(stackProducts, ({ Sku }) => (Sku ? [Sku] : []));
        return {
          id: document.Id,
          bundleChoices: _map(stackProducts, ({ ChoiceId }) => ChoiceId),
          bundleSkus,
          Stacks: _keyBy(document.Stacks, 'StackId'),
          ...document,
        };
      }
      return {
        Stacks: _keyBy(document.Stacks, 'StackId'),
        ...document,
      };
    }

    if (ModularDesignType === 'WallStorage') {
      return {
        ...document,
      };
    }

    return {
      Id: document.Id
    };
  });

  return _keyBy(documents, 'Id');
};
